import { mediaUrl } from "../lib/api";

function formatDuration(sec) {
  const s = Math.round(sec);
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}

export default function PostMedia({ post }) {
  return (
    <>
      {post.video_path && (
        <div className="relative bg-black border-y border-[#262626]">
          <video
            data-testid={`post-video-${post.id}`}
            src={mediaUrl(post.video_path)}
            poster={post.thumb_path ? mediaUrl(post.thumb_path) : undefined}
            controls
            preload="none"
            className="w-full max-h-[560px]"
          />
          {post.duration > 0 && (
            <span
              data-testid={`post-duration-${post.id}`}
              className="absolute top-2 right-2 bg-black/80 border border-[#404040] text-white text-[10px] font-semibold tracking-widest px-2 py-1 rounded-sm pointer-events-none"
            >
              {formatDuration(post.duration)}
            </span>
          )}
        </div>
      )}

      {post.image_paths?.length > 0 && (
        <div
          className={`border-y border-[#262626] bg-black grid gap-0.5 ${
            post.image_paths.length === 1 ? "grid-cols-1" : "grid-cols-2"
          }`}
          data-testid={`post-images-${post.id}`}
        >
          {post.image_paths.map((p, i) => (
            <img
              key={p}
              src={mediaUrl(p)}
              alt={`Match photo ${i + 1}`}
              loading="lazy"
              className={`w-full object-cover ${
                post.image_paths.length === 1 ? "max-h-[560px]" : "h-56 md:h-64"
              }`}
            />
          ))}
        </div>
      )}
    </>
  );
}
